import { useEffect, useState } from "react";
import { ArrowRight, Volume2, VolumeX } from "lucide-react";
import { Logo } from "./Logo";
import { useContent } from "@/context/ContentContext";

const KEY = "eden-intro-seen";

export function WelcomeIntro() {
  const { content } = useContent();
  const intro = content?.intro || {};
  const media = content?.media || {};
  const [show, setShow] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    if (!intro.enabled || !media.store_video_url) return;
    if (window.location.pathname.startsWith("/gestao")) return;
    if (sessionStorage.getItem(KEY) || (intro.once_per_device && localStorage.getItem(KEY))) return;
    setShow(true);
  }, [intro.enabled, intro.once_per_device, media.store_video_url]);

  useEffect(() => {
    if (!show) return undefined;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, [show]);

  const enter = () => {
    sessionStorage.setItem(KEY, "1");
    if (intro.once_per_device) localStorage.setItem(KEY, "1");
    setLeaving(true);
    setTimeout(() => setShow(false), 500);
  };

  if (!show) return null;
  return (
    <div className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-eden-bg transition-opacity duration-500 ${leaving ? "opacity-0" : "opacity-100"}`} role="dialog" aria-modal="true" aria-label="Boas-vindas ao EDEN RP" data-testid="welcome-intro">
      <video className="absolute inset-0 h-full w-full object-cover" autoPlay muted={muted} loop playsInline poster={media.store_poster_url || undefined} aria-hidden="true" data-testid="welcome-video">
        <source src={media.store_video_url} />
      </video>
      <div className="absolute inset-0 bg-gradient-to-t from-eden-bg via-eden-bg/55 to-eden-bg/30" aria-hidden="true" />
      <div className="grain absolute inset-0 opacity-40" aria-hidden="true" />
      <div className="relative flex max-w-3xl flex-col items-center px-6 text-center">
        <Logo url={media.logo_url} className="h-14 animate-fade-up" textClass="text-2xl" />
        {intro.eyebrow && <p className="eyebrow mt-10 animate-fade-up [animation-delay:120ms]" data-testid="welcome-eyebrow">{intro.eyebrow}</p>}
        <h1 className="mt-5 text-4xl font-extrabold leading-[1.02] tracking-tight text-eden-text animate-fade-up [animation-delay:220ms] sm:text-5xl lg:text-6xl" data-testid="welcome-title">{intro.title}</h1>
        {intro.text && <p className="mt-6 max-w-xl text-base leading-relaxed text-eden-secondary animate-fade-up [animation-delay:320ms] sm:text-lg" data-testid="welcome-text">{intro.text}</p>}
        <button type="button" onClick={enter} autoFocus className="btn-primary mt-10 h-12 px-8 text-sm animate-fade-up [animation-delay:420ms]" data-testid="welcome-enter-button">
          {intro.button || "Entrar"} <ArrowRight size={16} aria-hidden="true" />
        </button>
      </div>
      <button type="button" onClick={() => setMuted((m) => !m)} className="absolute bottom-6 right-6 grid h-10 w-10 place-items-center rounded-full border border-eden-border bg-eden-bg/70 text-eden-text backdrop-blur hover:border-eden-orange" aria-label={muted ? "Ativar som" : "Silenciar"} data-testid="welcome-mute">
        {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
      </button>
      <button type="button" onClick={enter} className="absolute left-6 top-6 font-mono text-[11px] uppercase tracking-widest text-eden-muted hover:text-eden-text" data-testid="welcome-skip">Saltar intro</button>
    </div>
  );
}
